import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { AGE_GROUP_ID_KEY } from '@portal/common/models/data-key';
import { DropdownOption } from '@portal/common/types';

import { getAgeGroupsOrder } from '../../store/data-explorer/selectors';
import ChartDropdown from '../ChartDropdown';

type Props = React.ComponentPropsWithoutRef<typeof ChartDropdown>;

const AgeGroupsDropdown = (props: Props) => {
    const order = useSelector(getAgeGroupsOrder);

    const sortAgeGroups = useCallback(
        (options: DropdownOption[]): DropdownOption[] =>
            order ? options.sort((a, b) => order[a] - order[b]) : options,
        [order]
    );

    return (
        <ChartDropdown {...props} filterKey={AGE_GROUP_ID_KEY} preprocessOptions={sortAgeGroups} />
    );
};

export default AgeGroupsDropdown;
